import type { VariantImagesDefinition } from 'types/images'

import { MILICAM01_IMAGES } from './default'

export const MILICAM01_BLACK_MALE_IMAGES = {
  ...MILICAM01_IMAGES,
  welcomeAgeBuckets: {
    heroBackground: {
      ...MILICAM01_IMAGES.welcomeAgeBuckets.heroBackground,
      srcSet: [
        '/images/milicam01/black-male/welcome-age-buckets/hero_background.webp',
        '/images/milicam01/black-male/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    heroBackgroundDesktop: {
      ...MILICAM01_IMAGES.welcomeAgeBuckets.heroBackgroundDesktop,
      srcSet: [
        '/images/milicam01/black-male/welcome-age-buckets/hero_background_desktop.webp',
        '/images/milicam01/black-male/welcome-age-buckets/hero_background_desktop@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    pitch: {
      ...MILICAM01_IMAGES.socialProofMillions.pitch,
      srcSet: [
        '/images/milicam01/black-male/social_proof_millions.webp',
        '/images/milicam01/black-male/social_proof_millions@2x.webp',
      ],
    },
    group: {
      ...MILICAM01_IMAGES.socialProofMillions.group,
      srcSet: [
        '/images/milicam01/black-male/social-proof-millions/group.webp',
        '/images/milicam01/black-male/social-proof-millions/group@2x.webp',
      ],
    },
  },
  experience: {
    background: {
      ...MILICAM01_IMAGES.experience.background,
      srcSet: [
        '/images/milicam01/black-male/experience.webp',
        '/images/milicam01/black-male/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...MILICAM01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/milicam01/black-male/experience_pitch.webp',
        '/images/milicam01/black-male/experience_pitch@2x.webp',
      ],
    },
  },
  mainGoal: {
    gainMuscle: {
      ...MILICAM01_IMAGES.mainGoal.gainMuscle,
      srcSet: [
        '/images/milicam01/black-male/main-goal/main_goal_option_gain_muscle.webp',
        '/images/milicam01/black-male/main-goal/main_goal_option_gain_muscle@2x.webp',
      ],
    },
    improveFitness: {
      ...MILICAM01_IMAGES.mainGoal.improveFitness,
      srcSet: [
        '/images/milicam01/black-male/main-goal/main_goal_option_improve_fitness.webp',
        '/images/milicam01/black-male/main-goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      ...MILICAM01_IMAGES.mainGoal.loseWeight,
      srcSet: [
        '/images/milicam01/black-male/main-goal/main_goal_option_lose_weight.webp',
        '/images/milicam01/black-male/main-goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  struggle: {
    back: {
      ...MILICAM01_IMAGES.struggle.back,
      srcSet: [
        '/images/milicam01/black-male/struggle/struggle_option_back.webp',
        '/images/milicam01/black-male/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      ...MILICAM01_IMAGES.struggle.knees,
      srcSet: [
        '/images/milicam01/black-male/struggle/struggle_option_knees.webp',
        '/images/milicam01/black-male/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      ...MILICAM01_IMAGES.struggle.none,
      srcSet: [
        '/images/milicam01/black-male/struggle/struggle_option_none.webp',
        '/images/milicam01/black-male/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      ...MILICAM01_IMAGES.bodyTypePitch.endomorph,
      srcSet: [
        '/images/milicam01/black-male/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/milicam01/black-male/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      ...MILICAM01_IMAGES.bodyTypePitch.mesomorph,
      srcSet: [
        '/images/milicam01/black-male/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/milicam01/black-male/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      ...MILICAM01_IMAGES.bodyTypePitch.ectomorph,
      srcSet: [
        '/images/milicam01/black-male/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/milicam01/black-male/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      ...MILICAM01_IMAGES.strugglePitch.knees,
      srcSet: [
        '/images/milicam01/black-male/struggle-pitch/struggle_pitch_knees.webp',
        '/images/milicam01/black-male/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      ...MILICAM01_IMAGES.strugglePitch.back,
      srcSet: [
        '/images/milicam01/black-male/struggle-pitch/struggle_pitch_back.webp',
        '/images/milicam01/black-male/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      ...MILICAM01_IMAGES.strugglePitch.both,
      srcSet: [
        '/images/milicam01/black-male/struggle-pitch/struggle_pitch_both.webp',
        '/images/milicam01/black-male/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extra: {
      ...MILICAM01_IMAGES.physicalBuild.extra,
      srcSet: [
        '/images/milicam01/black-male/physical-build/physical_build_option_significantly_overweight.webp',
        '/images/milicam01/black-male/physical-build/physical_build_option_significantly_overweight@2x.webp',
      ],
    },
    plusSize: {
      ...MILICAM01_IMAGES.physicalBuild.plusSize,
      srcSet: [
        '/images/milicam01/black-male/physical-build/physical_build_option_bigger.webp',
        '/images/milicam01/black-male/physical-build/physical_build_option_bigger@2x.webp',
      ],
    },
    average: {
      ...MILICAM01_IMAGES.physicalBuild.average,
      srcSet: [
        '/images/milicam01/black-male/physical-build/physical_build_option_medium_build.webp',
        '/images/milicam01/black-male/physical-build/physical_build_option_medium_build@2x.webp',
      ],
    },
    skinnySlim: {
      ...MILICAM01_IMAGES.physicalBuild.skinnySlim,
      srcSet: [
        '/images/milicam01/black-male/physical-build/physical_build_option_slender.webp',
        '/images/milicam01/black-male/physical-build/physical_build_option_slender@2x.webp',
      ],
    },
  },
  bodyGoal: {
    bitLeaner: {
      ...MILICAM01_IMAGES.bodyGoal.bitLeaner,
      srcSet: [
        '/images/milicam01/black-male/body-goal/body_goal_option_a_bit_leaner.webp',
        '/images/milicam01/black-male/body-goal/body_goal_option_a_bit_leaner@2x.webp',
      ],
    },
    athletic: {
      ...MILICAM01_IMAGES.bodyGoal.athletic,
      srcSet: [
        '/images/milicam01/black-male/body-goal/body_goal_option_athletic.webp',
        '/images/milicam01/black-male/body-goal/body_goal_option_athletic@2x.webp',
      ],
    },
    shredded: {
      ...MILICAM01_IMAGES.bodyGoal.shredded,
      srcSet: [
        '/images/milicam01/black-male/body-goal/body_goal_option_shredded.webp',
        '/images/milicam01/black-male/body-goal/body_goal_option_shredded@2x.webp',
      ],
    },
    extraBulky: {
      ...MILICAM01_IMAGES.bodyGoal.extraBulky,
      srcSet: [
        '/images/milicam01/black-male/body-goal/body_goal_option_extra_bulky.webp',
        '/images/milicam01/black-male/body-goal/body_goal_option_extra_bulky@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      ...MILICAM01_IMAGES.problemAreas.belly,
      srcSet: [
        '/images/milicam01/black-male/problem-areas/problem_areas_option_belly.webp',
        '/images/milicam01/black-male/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    pecs: {
      ...MILICAM01_IMAGES.problemAreas.pecs,
      srcSet: [
        '/images/milicam01/black-male/problem-areas/problem_areas_option_pecs.webp',
        '/images/milicam01/black-male/problem-areas/problem_areas_option_pecs@2x.webp',
      ],
    },
    arms: {
      ...MILICAM01_IMAGES.problemAreas.arms,
      srcSet: [
        '/images/milicam01/black-male/problem-areas/problem_areas_option_arms.webp',
        '/images/milicam01/black-male/problem-areas/problem_areas_option_arms@2x.webp',
      ],
    },
    thighs: {
      ...MILICAM01_IMAGES.problemAreas.thighs,
      srcSet: [
        '/images/milicam01/black-male/problem-areas/problem_areas_option_legs.webp',
        '/images/milicam01/black-male/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      ...MILICAM01_IMAGES.howOftenExercise.background,
      srcSet: [
        '/images/milicam01/black-male/how_often_exercise.webp',
        '/images/milicam01/black-male/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      ...MILICAM01_IMAGES.howOftenWalks.background,
      srcSet: [
        '/images/milicam01/black-male/how_often_walks.webp',
        '/images/milicam01/black-male/how_often_walks@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      ...MILICAM01_IMAGES.flexible.background,
      srcSet: [
        '/images/milicam01/black-male/flexible.webp',
        '/images/milicam01/black-male/flexible@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    ...MILICAM01_IMAGES.bigResultsPitch,
    first: {
      ...MILICAM01_IMAGES.bigResultsPitch.first,
      srcSet: [
        '/images/milicam01/black-male/big-results-pitch/big_results_pitch_01.webp',
        '/images/milicam01/black-male/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      ...MILICAM01_IMAGES.bigResultsPitch.second,
      srcSet: [
        '/images/milicam01/black-male/big-results-pitch/big_results_pitch_02.webp',
        '/images/milicam01/black-male/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      ...MILICAM01_IMAGES.bigResultsPitch.third,
      srcSet: [
        '/images/milicam01/black-male/big-results-pitch/big_results_pitch_03.webp',
        '/images/milicam01/black-male/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
  },
  waterIntake: {
    header: {
      ...MILICAM01_IMAGES.waterIntake.header,
      srcSet: [
        '/images/milicam01/black-male/water_intake.webp',
        '/images/milicam01/black-male/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      ...MILICAM01_IMAGES.sleepDuration.header,
      srcSet: [
        '/images/milicam01/black-male/sleep_duration.webp',
        '/images/milicam01/black-male/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      ...MILICAM01_IMAGES.wellnessProfile.extended,
      srcSet: [
        '/images/milicam01/black-male/wellness-profile/wellness_profile_overweight.webp',
        '/images/milicam01/black-male/wellness-profile/wellness_profile_overweight@2x.webp',
      ],
    },
    fullFigured: {
      ...MILICAM01_IMAGES.wellnessProfile.fullFigured,
      srcSet: [
        '/images/milicam01/black-male/wellness-profile/wellness_profile_bigger.webp',
        '/images/milicam01/black-male/wellness-profile/wellness_profile_bigger@2x.webp',
      ],
    },
    midSized: {
      ...MILICAM01_IMAGES.wellnessProfile.midSized,
      srcSet: [
        '/images/milicam01/black-male/wellness-profile/wellness_profile_medium_build.webp',
        '/images/milicam01/black-male/wellness-profile/wellness_profile_medium_build@2x.webp',
      ],
    },
    slim: {
      ...MILICAM01_IMAGES.wellnessProfile.slim,
      srcSet: [
        '/images/milicam01/black-male/wellness-profile/wellness_profile_slender.webp',
        '/images/milicam01/black-male/wellness-profile/wellness_profile_slender@2x.webp',
      ],
    },
  },
  subscription: {
    beforeBigger: {
      ...MILICAM01_IMAGES.subscription.beforeBigger,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_bigger.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_bigger@2x.webp',
      ],
    },
    beforeMediumBuild: {
      ...MILICAM01_IMAGES.subscription.beforeMediumBuild,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_medium_build.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_medium_build@2x.webp',
      ],
    },
    beforeSignificantlyOverweight: {
      ...MILICAM01_IMAGES.subscription.beforeSignificantlyOverweight,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_significantly_overweight.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_significantly_overweight@2x.webp',
      ],
    },
    beforeSlender: {
      ...MILICAM01_IMAGES.subscription.beforeSlender,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_slender.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_before_slender@2x.webp',
      ],
    },
    afterAthletic: {
      ...MILICAM01_IMAGES.subscription.afterAthletic,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_athletic.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_athletic@2x.webp',
      ],
    },
    afterBitLeaner: {
      ...MILICAM01_IMAGES.subscription.afterBitLeaner,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_a_bit_leaner.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_a_bit_leaner@2x.webp',
      ],
    },
    afterExtraBulky: {
      ...MILICAM01_IMAGES.subscription.afterExtraBulky,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_extra_bulky.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_extra_bulky@2x.webp',
      ],
    },
    afterShredded: {
      ...MILICAM01_IMAGES.subscription.afterShredded,
      srcSet: [
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_shredded.webp',
        '/images/milicam01/black-male/subscription/goal-body/paywall_comparison_after_shredded@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof MILICAM01_IMAGES>
